import React, { useEffect, useState } from "react"
import { View } from "react-native"
import { useDispatch, useSelector } from "react-redux";
import Colors from "../../constants/Colorsv2";
import { Text, TouchableOpacity } from "../../globalComponents/NativeOverrides";
import { social_getPodcastByIdNoStore, social_getPodcastEpisodeByIdNoStore, social_loadPodcastEpisodes, social_updatePlayingPodcastEpisode } from "../../store/actionsv1/social";
import { PodcastEpisodesProps, PodcastProps } from "../../store/types/soc_svc";
import { getPodEpisodeImage, getPodImage } from "./helpers/podcasts";
import { Helmet } from "react-helmet-async";
import { SocialComponents } from "be-components";
import { util_updateShare } from "../../store/actionsv1/utils";
import { useSafeAreaInsets } from "react-native-safe-area-context";



const PodcastEpisodes = ({ navigation, route }:any) => {
    const [ pod_data, setPodData ] = useState<{
        podcast?:PodcastProps,
        podcast_episode?:PodcastEpisodesProps
    }>({
        
    });
    const { podcast, podcast_episode } = pod_data
    
    const dispatch = useDispatch();
    const insets = useSafeAreaInsets();
    const player = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id);

    useEffect(() => {
        if(!route.params?.podcast_id){ return }
        getPodcastFromServer(route.params.podcast_id)
    },[route.params?.podcast_id]);

    const getPodcastFromServer = async(id:string) => {
        const pod = await social_getPodcastByIdNoStore(id);
        let pod_ep:PodcastEpisodesProps|undefined = undefined
        if(route.params.podcast_episode_id){ 
            pod_ep = await social_getPodcastEpisodeByIdNoStore(route.params.podcast_episode_id) 
            if(pod_ep){ dispatch(social_updatePlayingPodcastEpisode(pod_ep)) }
        }
        setPodData({ podcast:pod, podcast_episode: pod_ep });
    }

   return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            {podcast ?
            <Helmet>
                <title>{podcast_episode? podcast_episode.title : podcast.title}</title>
                <meta name='description' content={podcast_episode ? podcast_episode.description : podcast.description }/>
                <meta name='og:image' content={podcast_episode ? getPodEpisodeImage(podcast_episode, podcast) : getPodImage(podcast)} />
            </Helmet>
            :<></>}
            <SocialComponents.PodcastModule
                podcast_id={route.params.podcast_id}
                padding_insets={insets}
                player_id={player.player_id}
                onSelectPlayer={(p) => navigation.push('SocialProfile', { player_id: p.player_id })}
                onSelectEpisode={(ep) => dispatch(social_updatePlayingPodcastEpisode(ep))}
                onShareEpisode={(ep) => {
                    dispatch(util_updateShare({
                        share_key: `invite_pod_ep_${ep.podcast_episode_id}_share`,
                        visible:true,
                        title: `${ep.title}`,
                        body: undefined,
                        type_id: ep.podcast_episode_id,
                        generator:'player',
                        link_type: 'user_generated_link',
                        link_sub_type: 'podcast_link',
                        redirect_url: `https://app.bettoredge.com/social/podcasts/podcast/${route.params.podcast_id}/${ep.podcast_episode_id}`,
                    }))
                }}
                onSharePodcast={(p) => {
                    dispatch(util_updateShare({
                        share_key: `invite_pod_${p.podcast_id}_share`,
                        visible:true,
                        title: `${p.title}`,
                        body: undefined,
                        type_id: p.podcast_id,
                        generator:'player',
                        link_type: 'user_generated_link',
                        link_sub_type: 'podcast_link',
                        redirect_url: `https://app.bettoredge.com/social/podcasts/podcast/${route.params.podcast_id}`,
                    }))
                }}
                onBack={() => navigation.goBack()}
            />
            {player?.role == 'admin' ?
            <TouchableOpacity style={{ position:'absolute', top:insets.top + 10, right:5, borderRadius:22, backgroundColor:Colors.brand.electric, padding:10 }}
            onPress={() => social_loadPodcastEpisodes(route.params.podcast_id)}>
                <Text size={12} color={Colors.shades.white} weight="bold">LOAD EPISODES</Text>
            </TouchableOpacity>
            :<></>}
        </View>
   )
}


export default PodcastEpisodes